import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';
import { getCurrentUser } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { BADGE_ACTIVITY_STREAM } from '../../../streams';
import { AppState } from '../../../../types/store';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../selectors/users';
import { getModuleDataByModuleType } from '../../../selectors/modules';
import { ModuleType } from '../../../../types/modules';
import { Props as WidgetProps } from './MyBadges';
import { Props as BoxProps } from './MyBadgesBoxWide';

type Props = BoxProps & WidgetProps;
type StateProps = Pick<
  Props,
  | 'currentUser'
  | 'profileOwnerUser'
  | 'badges'
  | 'badgeActivity'
  | 'hasMoreBadgeActivity'
  | 'isCurrentUserProfileOwner'
  | 'isFetchingBadgeActivity'
  | 'isEmpty'
  | 'totalReceived'
  | 'totalSent'
>;
type DispatchProps = Pick<Props, 'fetchMoreBadgeActivity'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const { badges } = getModuleDataByModuleType(state, ModuleType.ABOUT);
  const { totalReceived, totalSent } = getModuleDataByModuleType(
    state,
    ModuleType.BADGES_ACTIVITY
  );
  return {
    currentUser: getCurrentUser(state)!,
    profileOwnerUser: getProfileOwnerUser(state),
    isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
    badges,
    badgeActivity: streamSelectors.getItems(state, BADGE_ACTIVITY_STREAM),
    hasMoreBadgeActivity: streamSelectors.hasMore(state, BADGE_ACTIVITY_STREAM),
    isFetchingBadgeActivity: streamSelectors.isFetching(
      state,
      BADGE_ACTIVITY_STREAM
    ),
    isEmpty: !badges.length,
    totalReceived,
    totalSent,
  };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  fetchMoreBadgeActivity: () =>
    dispatch(withOffset.actions.fetch(BADGE_ACTIVITY_STREAM)),
});

export default connect(mapStateToProps, mapDispatchToProps);
